export default __webpack_public_path__ + "d53ab2381a0e5c6aac464cafb89a6619.png";